import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { createRequest, } from '../../../reducers/actions/request-actions';
import { getVehicle, getVehicleByUser } from '../../../services/request.service';
import { useNavigate  } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import Swal from "sweetalert2";
import InputCheckBoxVehicles from '../InputCheckBoxVehicle';


const Step3 = ({page, setPage, formData, setFormData}) => {
  let navigate = useNavigate();
  const [vehicles, setVehicles] = useState([])
  const [successful, setSuccessful] = useState(false);
  const [checked, setChecked] = useState(false);
  const [allVehicles, setAllVehicles] = useState([])
  const [loading, setLoading] = useState(false);

  const auth = useSelector((state) => state.auth.user.id);
  
  useEffect(() => {
    getVehicle(auth).then((response) => {
      setAllVehicles(response);
    });
  }, [])

  console.log(formData)
  
  const data = (vehicleId, check) =>{
    if(vehicles.find((oneVehicle)=>oneVehicle.id === vehicleId)){
      setVehicles(vehicles.filter((vehicle) => vehicle.id !== vehicleId))
    }else{
      setVehicles([...vehicles, { id: vehicleId }]);
    }
  }
  
  console.log(vehicles)

  const {
    handleSubmit,
  } = useForm();
  
  const dispatch = useDispatch();

  const showAlert = () => {
    Swal.fire({
      title: "Advertencia",
      text: "Deseas enviar la solicitud?",
      icon: "info",
      showDenyButton: true,
      denyButtonText: "No",
      confirmButtonText:"Si",
      confirmButtonColor: "#3085d6",
    }).then(response => {
      if(response.isConfirmed){
        onSubmit();
        Swal.fire({
          title: "Registro exitoso",
          text: "Solicitud creada con exito",
          icon: "success",
          confirmButtonText:"Ok",
          confirmButtonColor: "#3085d6",
        })
      }
    });
  }

  const handleChange = (e) => {
    setChecked(e.target.checked);
  };

  const onSubmit = (e) => {
    setSuccessful(false);
    dispatch(createRequest(formData),
      navigate('/request/all'),
    )
  }
  


  const handleAddVehicles = () =>{
    setFormData({...formData, vehicles: vehicles})
     }


  return (
    <div className="container">
      <form onSubmit={handleSubmit(showAlert)}>
        <div className={`row g-3`}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h5 className="Request-form-h4">{"Personal"}</h5>
          </div>
          <div className="vehicle-content-display">
            <ul className={`list-group`}>
              <ul className="list-group-item d-none d-lg-inline-block border-bottom ul-request">
                <div className="row">
                  <div className="col-lg list-request-title">
                    <strong>PLACA</strong>
                  </div>
                  <div className="col list-request-title"></div>
                </div>
              </ul>
              {allVehicles?.map((vehicle) => (
                <a
                  className={`list-group-item list-group-item-action ul-request ul-request`}
                  key={vehicle.id}
                >
                  <div className="row">
                    <div className="col list-request-title">
                      <strong>{`${vehicle.letters}${vehicle.numbers}`}</strong>
                    </div>
                    <InputCheckBoxVehicles setData={data} dataId={vehicle.id} />
                  </div>
                </a>
              ))}
            </ul>
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginTop: "15px",
              }}
            >
              <button
                className={"btn btn-success btn-sm"}
                onClick={() => {
                  setPage(page - 1);
                  setVehicles([]);
                }}
              >
                Anterior
              </button>
              <button className={"btn btn-success btn-sm"} onClick={(e)=>{
                setFormData({
                  ...formData,
                  vehicles,
                });
              }}>
                Enviar
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default Step3;